import { render, staticRenderFns } from "./comp-tagihan-info.vue?vue&type=template&id=4fef5494&scoped=true&"
import script from "./comp-tagihan-info.vue?vue&type=script&lang=js&"
export * from "./comp-tagihan-info.vue?vue&type=script&lang=js&"
import style0 from "./comp-tagihan-info.vue?vue&type=style&index=0&id=4fef5494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fef5494",
  null
  
)

export default component.exports